import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IDeliveryZone } from '../../interfaces/IDeliveryZone';
import { IOrder } from '../../interfaces/IOrder';

const apiUrl = Globals.apiPath + '/deliveryZones';

export default class DeliveryZonesService {
  constructor() {}

  static async getByBranch(branchId: number): Promise<IDeliveryZone[]> {
    let res = await axios.get<IDeliveryZone[]>(`${apiUrl}/b/${branchId}`);
    return res.data;
  }

  async saveByBranch(
    branchId: number,
    zones: IDeliveryZone[]
  ): Promise<IDeliveryZone[]> {
    let res = await axios.put<IDeliveryZone[]>(`${apiUrl}/b/${branchId}`, {
      zones,
    });
    return res.data;
  }

  async activate(deliveryZone: IDeliveryZone): Promise<IDeliveryZone> {
    let res = await axios.post<IDeliveryZone>(
      `${apiUrl}/${deliveryZone.id}/activate`
    );
    return res.data;
  }

  async deactivate(deliveryZone: IDeliveryZone): Promise<IDeliveryZone> {
    let res = await axios.post<IDeliveryZone>(
      `${apiUrl}/${deliveryZone.id}/deactivate`
    );
    return res.data;
  }
}
